window.FA_QUIZ_FLOWS = window.FA_QUIZ_FLOWS || {};

window.FA_QUIZ_FLOWS['cortisol'] = {
  id: 'cortisol',
  klaviyoEvent: 'High Cortisol Quiz Completed',

  scoring: {
    map: {
      s1: [0, 1, 2, 3],
      s2: [1, 0],
      s3: [2, 3, 3, 2, 2],
      s4: [3, 0],
      s5: [3, 3, 2, 0],
      s6: [3, 2, 1, 1],
      s9: [0, 1, 2, 3],
      s10: [3, 2, 0, 0],
      s11: [3, 0, 1],
      s12: [0, 1, 2, 3]
    },
    tiers: [
      { id: 'high', min: 18 },
      { id: 'medium', min: 10 },
      { id: 'low', min: 0 }
    ],
    overrides: [
      { when: { s5: 3, s4: 1 }, force: 'low' },
      { when: { s6: 3 }, fromTier: 'high', toTier: 'medium' },
      { when: { s4: 0, s5: [0, 1] }, fromTier: 'low', toTier: 'medium' }
    ]
  },

  gauge: {
    title: 'Your Cortisol Balance Score',
    scoreLabel: 'Your score:',
    labels: ['DISRUPTED', 'LOW', 'NORMAL', 'OPTIMAL']
  },

  chart: {
    yLabels: ['Optimal', 'Normal', 'Low', 'Disrupted'],
    xLabels: ['Now', '30 days', '60 days', '90 days'],
    calloutLabel: 'Your level'
  },

  steps: [
    {
      id: 'question_1',
      type: 'hero',
      title: 'Find out if high cortisol is <br>silently affecting your quality of life',
      sub: "This 2-minute assessment analyzes your stress symptoms, habits, and <br>cortisol risk to find what's driving it.",
      testimonial: { text: "I've started sending this to patients before their first visit. It asks the right questions for people with stress.", initial: 'P', name: 'DR. PAREKH', badge: 'LONGEVITY EXPERT' },
      qLabel: 'How old are you?',
      q: 's1',
      options: ['In my 20s', 'In my 30s', 'In my 40s', 'In my 50s or later']
    },
    {
      id: 'question_2',
      type: 'question',
      title: 'What best describes you?',
      q: 's2',
      options: ['Female', 'Male'],
      helper: 'Cortisol patterns differ by biological sex. We tailor your results accordingly.'
    },
    {
      id: 'question_3',
      type: 'question',
      title: 'Which of these is bothering you <br>most right now?',
      q: 's3',
      options: ["Belly fat that won't go away", 'Feeling wired but tired', 'Waking up at 3–4am', 'Constant sugar or salt cravings', 'Feeling puffy and swollen']
    },
    {
      id: 'question_4',
      type: 'question',
      title: 'Do you feel tense even when nothing is wrong, like your body never <br>fully switches off?',
      titleWide: true,
      q: 's4',
      options: ['Yes', 'No']
    },
    {
      id: 'question_5',
      type: 'question',
      title: 'How do you feel when you <br>wake up in the morning?',
      q: 's5',
      options: ['Exhausted — like I never slept', 'Anxious — mind racing immediately', 'Groggy — need caffeine to function', 'Refreshed and calm — no complaints']
    },
    {
      id: 'question_6',
      type: 'question',
      title: 'When did you start feeling this <br>constant stress?',
      q: 's6',
      options: ['Over a year ago', 'In the past year', 'In the past few months', 'It comes and goes']
    },
    {
      id: 'question_7',
      type: 'question',
      title: 'What would you change first if you <br>could?',
      q: 's7',
      options: ['Flatter stomach — less “cortisol belly”', 'Deep, uninterrupted sleep', 'Calm, steady energy all day', 'Fewer cravings, less puffiness', 'All of the above']
    },
    {
      id: 'social_proof',
      type: 'interstitial',
      title: 'You are in the right place.',
      sub: 'Over 100,000+ people have rebalanced their stress response and energy with the right supplement support.',
      cta: 'CONTINUE',
      testimonials: [
        { text: 'My 3am wake-ups stopped and my belly finally started shrinking. Thanks to the quiz!!!', initial: 'J', name: 'JESSICA, 34', badge: 'Verified Review' },
        { text: 'Wow took the simple quiz and I feel calm for the first time in years and my cravings are gone.', initial: 'A', name: 'AMANDA, 28', badge: 'Verified Review' }
      ]
    },
    {
      id: 'question_8',
      type: 'question',
      title: 'How would you describe your <br>current body composition?',
      q: 's9',
      options: ['Lean and toned', 'Average build', 'Soft with some muscle', 'Out of shape / low muscle tone']
    },
    {
      id: 'question_9',
      type: 'question',
      title: 'How many hours of quality sleep <br>do you get per night?',
      q: 's10',
      options: ['Less than 5 hours', '5–6 hours', '7–8 hours', 'More than 8 hours']
    },
    {
      id: 'question_10',
      type: 'question',
      title: 'Do you rely on caffeine to get <br>through the day?',
      q: 's11',
      options: ['Yes', 'No', 'Not sure'],
      why: 'Caffeine on a stressed, depleted system spikes cortisol even higher — keeping your body locked in fat-storage mode. Most high-cortisol people are stuck in this loop without knowing it.'
    },
    {
      id: 'analyzing',
      type: 'ring_loader',
      title: 'Analyzing your responses...',
      sub: 'Our algorithm is cross-referencing your answers with clinical stress data to estimate your cortisol impact.',
      ringLabel: 'analyzes',
      duration: 4000
    },
    {
      id: 'question_11',
      type: 'question',
      title: 'How often do you eat red <br>meat or fish?',
      sub: '(These are the primary natural sources of creatine)',
      q: 's12',
      options: ['Daily — most meals include meat/fish', 'Several times a week', 'Occasionally — mostly plant-based', 'Rarely/never — vegetarian or vegan'],
      why: 'Red meat and fish are the primary dietary sources of creatine — the fuel your brain and muscles burn through fastest under chronic stress. Low intake leaves you drained and wired at the same time.'
    },
    {
      id: 'building_profile',
      type: 'step_loader',
      variant: 'counter',
      title: 'Building your profile...',
      sub: 'Personalizing your cortisol assessment',
      onDone: 'score',
      steps: [
        { num: 1, title: 'Analyzing symptoms', text: 'Cross-checking your reported symptoms' },
        { num: 2, title: 'Cross-referencing lifestyle factors', text: 'Diet, sleep, and activity patterns' },
        { num: 3, title: 'Calibrating supplement protocol', text: 'Matching to clinical benchmarks' },
        { num: 4, title: 'Personalizing your result', text: 'Generating your assessment...' }
      ]
    },
    {
      id: 'results',
      type: 'result_gauge',
      eyebrow: 'YOUR CORTISOL ASSESSMENT',
      title: 'Your Results Are In',
      meansTitle: 'What This Means For You',
      cta: "SHOW ME WHAT'S POSSIBLE"
    },
    {
      id: 'projection',
      type: 'result_chart',
      eyebrow: 'YOUR PROJECTED IMPROVEMENT',
      title: 'Cortisol Balance Projection',
      sub: 'Based on your unique assessment profile',
      milestonesTitle: 'Expected Milestones',
      cta: 'GET MY OMNI PLAN'
    },
    {
      id: 'final_loader',
      type: 'step_loader',
      variant: 'ring',
      title: 'Applying your discount...',
      sub: 'Securing your personalized pricing',
      urgency: 'Your discount expires soon',
      onDone: 'redirect',
      steps: [
        { num: 1, title: 'Protocol calibrated', text: 'Your custom plan is ready' },
        { num: 2, title: 'Supply reserved', text: 'Stock allocated for your order' },
        { num: 3, title: 'Discount applied', text: '47% savings activated' },
        { num: 4, title: 'Generating your link', text: 'Creating secure checkout...' }
      ]
    }
  ],

  tiers: {
    high: {
      cls: 'fq-tier--high',
      levelLabel: 'SEVERELY DISRUPTED',
      pct: '18%',
      activeSegment: 0,
      alertTitle: 'HIGH CORTISOL PATTERN',
      alertText: 'Your stress response is stuck in overdrive. Immediate creatine support strongly recommended.',
      statusValue: 'CRITICAL',
      statusSub: 'DISRUPTED',
      riskValue: 'HIGH',
      riskSub: 'IMPACT',
      potential: '+60%',
      meansIntro: 'Left unchecked, a chronic cortisol pattern keeps draining your body. This directly affects:',
      meansBullets: ['Stubborn belly fat and puffiness', 'Sleep quality and 3am wake-ups', 'Daily energy and stamina', 'Your metabolism and long-term results'],
      meansClosing: '<strong>Good news, this is fixable, and creatine is one of the most effective solutions for your situation. Tap below to see which brand is right for you.</strong>',
      chartStartY: 3,
      lift: '+60%',
      levelColor: '#FF0000',
      calloutBg: '#FFE1E1',
      potentialColor: '#FF0000',
      milestones: [
        { label: 'WEEK 1–2', title: 'Loading Phase', text: 'OMNI Creatine Gummy starts refilling what chronic stress burns through fastest.' },
        { label: 'WEEK 3–4', title: 'Activation Phase', text: 'Energy steadies and the wired-but-tired feeling starts to lift.' },
        { label: 'MONTH 2–3', title: 'Optimization Phase', text: 'Full saturation reached. Calmer energy, better sleep, less cortisol belly.' }
      ]
    },
    medium: {
      cls: 'fq-tier--medium',
      levelLabel: 'ELEVATED',
      pct: '52%',
      activeSegment: 1,
      alertTitle: 'CORTISOL CREEPING UP',
      alertText: 'Your stress response is starting to tip out of balance. Proactive creatine support recommended.',
      statusValue: 'MILD',
      statusSub: 'DISRUPTED',
      riskValue: 'MODERATE',
      riskSub: 'IMPACT',
      potential: '+30%',
      meansIntro: 'Your cortisol balance is starting to slip. You may be noticing:',
      meansBullets: ['Reduced energy throughout the day', 'Lighter, more broken sleep', 'More cravings and puffiness', 'Gradual loss of muscle tone'],
      meansClosing: '<strong>Good news, this is fixable, and creatine is one of the most effective solutions for your situation. Tap below to see which brand is right for you.</strong>',
      chartStartY: 2,
      lift: '+30%',
      levelColor: '#F19800',
      calloutBg: '#FFF3DF',
      potentialColor: '#3B7DDD',
      milestones: [
        { label: 'WEEK 1–2', title: 'Loading Phase', text: 'OMNI Creatine Gummy begins topping up your stores before the slide continues.' },
        { label: 'WEEK 3–4', title: 'Activation Phase', text: 'Energy and recovery improve. Sleep starts to deepen.' },
        { label: 'MONTH 2–3', title: 'Optimization Phase', text: 'Full saturation reached. Steadier energy and a calmer stress response.' }
      ]
    },
    low: {
      cls: 'fq-tier--low',
      levelLabel: 'NEARLY BALANCED',
      pct: '74%',
      activeSegment: 2,
      alertTitle: 'BALANCED — ROOM TO OPTIMIZE',
      alertText: 'Your stress response is holding up — but not at full potential.',
      statusValue: 'GOOD',
      statusSub: 'DISRUPTED',
      riskValue: 'LOW',
      riskSub: 'IMPACT',
      potential: '+20%',
      meansIntro: "Your cortisol pattern looks healthy, but there's still untapped potential:",
      meansBullets: ['Enhanced energy and stamina throughout the day', 'Deeper, more restorative sleep', 'Fewer cravings and less puffiness', 'Better athletic performance and endurance'],
      meansClosing: '<strong>Many people at your level unlock noticeably faster results with creatine. Tap below to see which brand is right for you.</strong>',
      chartStartY: 1,
      lift: '+20%',
      levelColor: '#338411',
      calloutBg: '#E8F8E0',
      potentialColor: '#3B7DDD',
      milestones: [
        { label: 'WEEK 1–2', title: 'Top-Off Phase', text: 'OMNI Creatine Gummy tops your stores to full capacity. Subtle energy improvements.' },
        { label: 'WEEK 3–4', title: 'Enhancement', text: 'Consistent boost in daily energy, focus, and workout performance.' },
        { label: 'MONTH 2–3', title: 'Peak Performance', text: 'Operating at your best — full creatine optimization achieved.' }
      ]
    }
  }
};
